module.exports = __webpack_public_path__ + "img/샐러맨더.961a69ff.png";